import { render, staticRenderFns } from "./MarkTypeSettingsModal.vue?vue&type=template&id=7263838e&"
import script from "./MarkTypeSettingsModal.vue?vue&type=script&lang=js&"
export * from "./MarkTypeSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./MarkTypeSettingsModal.vue?vue&type=style&index=0&id=7263838e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports